// Copy-link control for the article share row (snippets/article-share.liquid).
// The button ships hidden and is only revealed when the Clipboard API is
// actually usable, so no-JS and insecure-context visitors never see a dead
// control — the network links beside it are plain hrefs and work regardless.
if (!customElements.get('article-share-copy')) {
  class ArticleShareCopy extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('.article-share__copy-button');
      this.message = this.querySelector('.article-share__copy-message');
      if (!this.button || !navigator.clipboard) return;

      this.button.hidden = false;
      this.onClick = this.onClick.bind(this);
      this.button.addEventListener('click', this.onClick);
    }

    disconnectedCallback() {
      this.button?.removeEventListener('click', this.onClick);
      clearTimeout(this.resetTimer);
    }

    async onClick() {
      const url = this.dataset.shareUrl;
      if (!url) return;

      try {
        await navigator.clipboard.writeText(url);
        this.showMessage(this.dataset.successMessage || '');
      } catch (error) {
        // Clipboard writes are rejected when the document isn't focused or
        // permission is denied — leave the URL selectable rather than failing
        // silently with no feedback.
        console.warn('[article-share] copy failed', error);
      }
    }

    showMessage(text) {
      if (!this.message) return;
      this.message.textContent = text;
      this.message.classList.add('article-share__copy-message--visible');

      clearTimeout(this.resetTimer);
      this.resetTimer = setTimeout(() => {
        this.message.textContent = '';
        this.message.classList.remove('article-share__copy-message--visible');
      }, 2500);
    }
  }

  customElements.define('article-share-copy', ArticleShareCopy);
}
